import { createSelector } from "@reduxjs/toolkit";

const getListPartnerTrackingStat = (state) => state.listPartnerTrackingStat;

const getIsGetPartnerTrackingStats = (state) => state.isGetPartnerTrackingStats;

const getListPartnerTrackingLink = (state) => state.listPartnerTrackingLink;

const getIsGetPartnerTrackingLinks = (state) => state.isGetPartnerTrackingLinks;

const getListPartnerCommission = (state) => state.listPartnerCommission;

const getIsGetPartnerCommission = (state) => state.isGetPartnerCommission;

const getCommissionTotal = (state) => state.commissionTotal;

const getTotalEarnedRange = (state) => state.totalEarnedRange;

const getTotalClawbackRange = (state) => state.totalClawbackRange;

const getListPartnerPayment = (state) => state.listPartnerPayment;

const getIsGetPartnerPayment = (state) => state.isGetPartnerPayment;

const getIsCreatePartnerPayment = (state) => state.isCreatePartnerPayment;

const getIsUpdatePartnerPayment = (state) => state.isUpdatePartnerPayment;

const getPaymentTotal = (state) => state.paymentTotal;

const getTotalAmountRange = (state) => state.totalAmountRange;

const getTotalEarned = (state) => state.totalEarned;

const getTotalPayment = (state) => state.totalPayment;

const getTotalClawback = (state) => state.totalClawback;

const getListCoupon = (state) => state.listCoupon;

const getIsGetCoupon = (state) => state.isGetCoupon;

const getIsCreateCoupon = (state) => state.isCreateCoupon;

const getIsUpdateCoupon = (state) => state.isUpdateCoupon;

const getIsRemoveCoupon = (state) => state.isRemoveCoupon;

const getIsCreateShortLink = (state) => state.isCreateShortLink;

const getIsAliasAlreadyCreated = (state) => state.isAliasAlreadyCreated;

const getIsGetW9Form = (state) => state.isGetW9Form;

const getW9FormContent = (state) => state.w9FormContent;

const getIsUpdateW9Form = (state) => state.isUpdateW9Form;

export const partnerTrackingStatsSelector = createSelector(
  [getListPartnerTrackingStat, getIsGetPartnerTrackingStats],
  (listPartnerTrackingStat, isGetPartnerTrackingStats) => ({
    listPartnerTrackingStat,
    isGetPartnerTrackingStats,
  })
);

export const partnerTrackingLinksSelector = createSelector(
  [getListPartnerTrackingLink, getIsGetPartnerTrackingLinks],
  (listPartnerTrackingLink, isGetPartnerTrackingLinks) => ({
    listPartnerTrackingLink,
    isGetPartnerTrackingLinks,
  })
);

export const partnerCommissionSelector = createSelector(
  [
    getListPartnerCommission,
    getIsGetPartnerCommission,
    getCommissionTotal,
    getTotalEarnedRange,
    getTotalClawbackRange,
  ],
  (
    listPartnerCommission,
    isGetPartnerCommission,
    commissionTotal,
    totalEarnedRange,
    totalClawbackRange
  ) => ({
    listPartnerCommission,
    isGetPartnerCommission,
    commissionTotal,
    totalEarnedRange,
    totalClawbackRange,
  })
);

export const partnerPaymentSelector = createSelector(
  [
    getListPartnerPayment,
    getIsGetPartnerPayment,
    getPaymentTotal,
    getTotalAmountRange,
    getIsCreatePartnerPayment,
    getIsUpdatePartnerPayment,
  ],
  (
    listPartnerPayment,
    isGetPartnerPayment,
    paymentTotal,
    totalAmountRange,
    isCreatePartnerPayment,
    isUpdatePartnerPayment
  ) => ({
    listPartnerPayment,
    isGetPartnerPayment,
    paymentTotal,
    totalAmountRange,
    isCreatePartnerPayment,
    isUpdatePartnerPayment,
  })
);

export const partnerSummarySelector = createSelector(
  [getTotalEarned, getTotalPayment, getTotalClawback],
  (totalEarned, totalPayment, totalClawback) => ({
    totalEarned,
    totalPayment,
    totalClawback,
  })
);

export const couponSelector = createSelector(
  [
    getListCoupon,
    getIsGetCoupon,
    getIsCreateCoupon,
    getIsUpdateCoupon,
    getIsRemoveCoupon,
  ],
  (
    listCoupon,
    isGetCoupon,
    isCreateCoupon,
    isUpdateCoupon,
    isRemoveCoupon
  ) => ({
    listCoupon,
    isGetCoupon,
    isCreateCoupon,
    isUpdateCoupon,
    isRemoveCoupon,
  })
);

export const shortLinkSelector = createSelector(
  [getIsCreateShortLink, getIsAliasAlreadyCreated],
  (isCreateShortLink, isAliasAlreadyCreated) => ({
    isCreateShortLink,
    isAliasAlreadyCreated,
  })
);

export const w9FormSelector = createSelector(
  [getIsGetW9Form, getIsUpdateW9Form, getW9FormContent],
  (isGetW9Form, isUpdateW9Form, w9FormContent) => ({
    isGetW9Form,
    isUpdateW9Form,
    w9FormContent,
  })
);
